<script>
import { visitService, clientService, therapistsService, zabiegiService, settingsService } from "@/services";
import AddEditClient from "@/components/clients/AddEditClient";
import VisitEditor from "@/components/visits/VisitEditor";
import SendSMS from "@/components/sms/SendSMS";

export default {
  name: "SMSCenter",
  components: {
    AddEditClient,
    VisitEditor,
    SendSMS
  },
  data() {
    return {
      loading: false,
      smsList: [],
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 25,
        sortBy: [],
        sortDesc: []
      },
      headers: [
        { text: "Data", value: "receivedAt", width: "150px" },
        { text: "Numer telefonu", value: "phoneNumber", width: "140px" },
        { text: "Treść", value: "text" },
        { text: "Pacjent", value: "clientName", width: "180px" },
        { text: "Wizyta", value: "visitId", width: "100px", sortable: false },
        { text: "Status", value: "isRead", width: "200px", sortable: false }
      ],
      // Filters
      onlyUnread: false,
      clientId: null,
      dateFrom: null,
      dateTo: null,
      // Client search
      clientKeyword: "",
      clientsList: [],
      isLoadingClients: false,
      // Date pickers
      dateFromMenu: false,
      dateToMenu: false,
      // Dialogs
      showClientDialog: false,
      selectedClientId: 0,
      showVisitDialog: false,
      visitData: null,
      showSmsDialog: false,
      smsPhoneNumber: null,
      smsClientId: null,
      // VisitEditor data
      typywizyt: [],
      fullZabiegiList: [],
      wybranaPlacowka: null
    };
  },
  computed: {
    dateFromFormatted() {
      return this.dateFrom ? this.formatDate(this.dateFrom) : "";
    },
    dateToFormatted() {
      return this.dateTo ? this.formatDate(this.dateTo) : "";
    }
  },
  watch: {
    options: {
      handler() {
        this.loadData();
      },
      deep: true
    },
    onlyUnread() {
      this.options.page = 1;
      this.loadData();
    },
    clientId() {
      this.options.page = 1;
      this.loadData();
    },
    dateFrom() {
      this.options.page = 1;
      this.loadData();
    },
    dateTo() {
      this.options.page = 1;
      this.loadData();
    },
    clientKeyword(val) {
      if (val && val.length >= 2) {
        this.searchClients(val);
      }
    }
  },
  mounted() {
    // Check if onlyUnread filter is passed via query
    if (this.$route.query.onlyUnread === "true") {
      this.onlyUnread = true;
    }
    // Load data needed for VisitEditor
    this.loadVisitEditorData();
  },
  methods: {
    loadVisitEditorData() {
      // Load typy wizyt
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result || [];
      }).catch(() => {
        console.error("Nie można pobrać typów wizyt.");
      });
      // Load zabiegi
      zabiegiService.getZabiegiList().then(response => {
        if (response.data && response.data.result) {
          this.fullZabiegiList = response.data.result;
        }
      }).catch(() => {
        console.error("Nie można pobrać listy zabiegów.");
      });
      // Load placowka from settings
      settingsService.GetCompanySettings().then(response => {
        if (response.data && response.data.result) {
          this.wybranaPlacowka = response.data.result.placowka || null;
        }
      }).catch(() => {
        console.error("Nie można pobrać ustawień firmy.");
      });
    },
    async loadData() {
      this.loading = true;
      try {
        const filter = {
          skipCount: (this.options.page - 1) * this.options.itemsPerPage,
          maxResultCount: this.options.itemsPerPage,
          onlyUnread: this.onlyUnread,
          clientId: this.clientId || null,
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || null
        };
        const response = await visitService.getSMSCenterList(filter);
        this.smsList = response.data.result.items;
        this.totalItems = response.data.result.totalCount;
      } catch (error) {
        console.error("Error loading SMS list:", error);
      } finally {
        this.loading = false;
      }
    },
    async markAsRead(item) {
      if (item.isRead) return;

      try {
        await visitService.markSMSAsRead(item.id, item.source);
        item.isRead = true;
        item.readAt = new Date().toISOString();
        // Refresh to get full data
        this.loadData();
      } catch (error) {
        console.error("Error marking SMS as read:", error);
      }
    },
    async searchClients(keyword) {
      if (this.isLoadingClients) return;

      this.isLoadingClients = true;
      try {
        const response = await clientService.getAll({
          query: keyword,
          page: 1,
          limit: 20
        });
        this.clientsList = response.data.result.items.map(c => ({
          id: c.id,
          name: `${c.name} ${c.surname}`,
          phone: c.phone
        }));
      } catch (error) {
        console.error("Error searching clients:", error);
      } finally {
        this.isLoadingClients = false;
      }
    },
    // Dialog methods
    openClient(clientId) {
      if (clientId) {
        this.selectedClientId = clientId;
        this.showClientDialog = true;
      }
    },
    closeClientDialog() {
      this.showClientDialog = false;
      this.selectedClientId = 0;
    },
    openVisit(visitId) {
      if (visitId) {
        this.visitData = { Id: visitId };
        this.showVisitDialog = true;
      }
    },
    closeVisitDialog() {
      this.showVisitDialog = false;
      this.visitData = null;
    },
    openSmsGateway(phoneNumber, clientId) {
      this.smsPhoneNumber = phoneNumber;
      this.smsClientId = clientId;
      this.showSmsDialog = true;
    },
    closeSmsDialog() {
      this.showSmsDialog = false;
      this.smsPhoneNumber = null;
      this.smsClientId = null;
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      return d.toLocaleDateString("pl-PL");
    },
    formatDateTime(dateString) {
      if (!dateString) return "";
      const d = new Date(dateString);
      return d.toLocaleString("pl-PL", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    truncateText(text, maxLength = 100) {
      if (!text) return "";
      return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    },
    clearFilters() {
      this.onlyUnread = false;
      this.clientId = null;
      this.dateFrom = null;
      this.dateTo = null;
    }
  }
};
</script>

<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <h2>Centrum SMS</h2>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="clearFilters">
              <v-icon left>fa-times</v-icon>
              Wyczyść filtry
            </v-btn>
          </v-card-title>
          <v-card-text>
            <!-- Filters -->
            <v-row align="center">
              <v-col cols="12" md="2">
                <v-checkbox
                  v-model="onlyUnread"
                  label="Tylko nieodczytane"
                  hide-details
                ></v-checkbox>
              </v-col>
              <v-col cols="12" md="3">
                <v-autocomplete
                  v-model="clientId"
                  :loading="isLoadingClients"
                  :items="clientsList"
                  :search-input.sync="clientKeyword"
                  cache-items
                  clearable
                  hide-details
                  item-value="id"
                  item-text="name"
                  label="Pacjent"
                  no-data-text="Wyszukaj pacjenta..."
                >
                  <template v-slot:item="data">
                    <v-list-item-content>
                      <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                      <v-list-item-subtitle>{{ data.item.phone }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" md="2">
                <v-menu
                  v-model="dateFromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFromFormatted"
                      label="Data od"
                      prepend-icon="fa-calendar"
                      readonly
                      clearable
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="dateFrom = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateFrom"
                    locale="pl"
                    @input="dateFromMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="2">
                <v-menu
                  v-model="dateToMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateToFormatted"
                      label="Data do"
                      prepend-icon="fa-calendar"
                      readonly
                      clearable
                      hide-details
                      v-bind="attrs"
                      v-on="on"
                      @click:clear="dateTo = null"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateTo"
                    locale="pl"
                    @input="dateToMenu = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" md="3" class="text-right">
                <v-btn color="primary" @click="loadData" :loading="loading">
                  <v-icon left>fa-sync</v-icon>
                  Odśwież
                </v-btn>
              </v-col>
            </v-row>

            <!-- Data Table -->
            <v-data-table
              :headers="headers"
              :items="smsList"
              :loading="loading"
              :options.sync="options"
              :server-items-length="totalItems"
              :footer-props="{
                'items-per-page-options': [10, 25, 50, 100]
              }"
              class="mt-4"
            >
              <template v-slot:item.receivedAt="{ item }">
                {{ formatDateTime(item.receivedAt) }}
              </template>

              <template v-slot:item.phoneNumber="{ item }">
                <a
                  @click="openSmsGateway(item.phoneNumber, item.clientId)"
                  class="text-decoration-none primary--text d-inline-flex align-center"
                  style="cursor: pointer; white-space: nowrap;"
                  title="Wyślij SMS"
                >
                  <v-icon small class="mr-1">fa-sms</v-icon>
                  <span>{{ item.phoneNumber }}</span>
                </a>
              </template>

              <template v-slot:item.text="{ item }">
                <v-tooltip bottom max-width="400">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      {{ truncateText(item.text) }}
                    </span>
                  </template>
                  <span>{{ item.text }}</span>
                </v-tooltip>
              </template>

              <template v-slot:item.clientName="{ item }">
                <a
                  v-if="item.clientId"
                  @click="openClient(item.clientId)"
                  class="text-decoration-none"
                  style="cursor: pointer"
                >
                  {{ item.clientName }}
                </a>
                <span v-else class="grey--text">Brak</span>
              </template>

              <template v-slot:item.visitId="{ item }">
                <v-btn
                  v-if="item.visitId"
                  icon
                  small
                  color="primary"
                  @click="openVisit(item.visitId)"
                  title="Otwórz wizytę"
                >
                  <v-icon small>fa-calendar-check</v-icon>
                </v-btn>
                <span v-else class="grey--text">-</span>
              </template>

              <template v-slot:item.isRead="{ item }">
                <v-chip
                  v-if="!item.isRead"
                  color="warning"
                  small
                  @click="markAsRead(item)"
                  style="cursor: pointer"
                >
                  <v-icon left small>fa-envelope</v-icon>
                  Nieodczytany
                </v-chip>
                <div v-else>
                  <v-icon small color="success" class="mr-1">fa-check</v-icon>
                  <span v-if="item.readAt" class="caption grey--text">
                    {{ formatDateTime(item.readAt) }}
                  </span>
                  <span v-if="item.readByUserName" class="caption grey--text">
                    ({{ item.readByUserName }})
                  </span>
                  <span v-if="item.visitId && !item.readAt" class="caption grey--text">
                    (powiązany z wizytą)
                  </span>
                </div>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Client Edit Dialog -->
    <AddEditClient
      v-if="showClientDialog"
      :visible="showClientDialog"
      :id="selectedClientId"
      @close="closeClientDialog"
    />

    <!-- Visit Editor Dialog -->
    <VisitEditor
      v-if="showVisitDialog"
      :visible="showVisitDialog"
      :visitData="visitData"
      :typywizyt="typywizyt"
      :zabiegi="fullZabiegiList"
      :placowka="wybranaPlacowka"
      @close="closeVisitDialog"
    />

    <!-- SMS Gateway Dialog -->
    <v-dialog
      v-model="showSmsDialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeSmsDialog">
            <v-icon>fa-times</v-icon>
          </v-btn>
          <v-toolbar-title>Wysyłka SMS</v-toolbar-title>
        </v-toolbar>
        <SendSMS
          v-if="showSmsDialog"
          :initialPhone="smsPhoneNumber"
          :initialClientId="smsClientId"
          :initialTemplate="'Wiadomość'"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
.v-data-table {
  font-size: 14px;
}
</style>
